// using module.exports here so gatsby-config can read it
module.exports = {
  // TODO: uncomment next line and enter your own public API key
  builderAPIKey: "dd3aeb1a2e6543f686ce3009747b9e04",
}
